import L from 'leaflet';

const iconDropoff = new L.Icon({
    iconUrl: '/assets/images/MarkerGreen.svg',
    iconRetinaUrl:'/assets/images/MarkerGreen.svg',
    iconAnchor: null,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(30, 45),
});

export { iconDropoff };